export const getDimensionsById = (id) => {
  const ele = document.getElementById(id);
  if (!ele) {
    return {};
  }
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    offsetTop,
    offsetBottom,
  };
};
